<template>
    <v-app id="inspire">
        <v-main>
            <v-container class="p-0">
                <div class="l-wrap">
                    <div class="l-inner">
                        <!--トップ-->
                        <div class="l-container" v-show="!avatarSelected">
                            <div class="c-hubpot-page bg-sagasu">
                                <div class="top-title">
                                    <img src="../assets/img/title-sagasu.png" />
                                </div>
                                <div class="avatar-list" :v-if="this.avatarData">
                                    <v-card v-for="(item, index) in this.avatarData" :key="item.updated_at" class="avatar-item" @click="loadExistAvatar(item, index)">
                                        <AvatarPreview :avatarData="item" :index="index" />
                                        <v-icon class="button-delete" @click.stop="deleteContact(index)"> mdi-trash-can </v-icon>
                                    </v-card>
                                </div>
                                <div v-if="(avatarData?.length < 3 && email) || avatarData == null || this.mode == 'kg'">
                                    <button type="button" class="button-new" @click="createNewAvatar">あたらしく つくる</button>
                                </div>
                                <div v-else>
                                    <button type="button" class="button-new" style="background-color: gray" @click="createNewAvatar" disabled>あたらしく つくる</button>
                                </div>
                            </div>
                        </div>
                        <!--性別選択-->
                        <div class="l-container" v-show="avatarSelected && !nameSet && !genderSelected && !avatorSet && !generatedImage">
                            <div class="c-top-page bg-sagasu">
                                <div class="top-title">
                                    <img src="../assets/img/title-sagasu.png" />
                                </div>
                                <div class="top-avator">
                                    <img src="../assets/img/top_avater_img.png" />
                                </div>
                                <button type="button" class="button-boy" @click="genderSelectBoy"><img src="../assets/img/btn-boy-sagasu.png" /></button>
                                <button type="button" class="button-girl" @click="genderSelectGirl"><img src="../assets/img/btn-girl-sagasu.png" /></button>
                                <button type="button" class="button-new" @click="backAvatarSelect" v-if="backAvatarSelectEnable">もどる</button>
                            </div>
                            <!-- <button type="button" class="button-logout" @click="logout">ログアウト</button> -->
                        </div>
                        <!--ジェネレーター-->
                        <div class="l-container" v-show="!nameSet && genderSelected && !avatorSet && !generatedImage">
                            <div class="c-interface">
                                <!--canvas-->
                                <div class="c-interface__canvas">
                                    <div class="c-preview">
                                        <canvas id="canvas" width="580" height="406" class="c-preview__canvas" style="display: none"></canvas>
                                        <canvas id="face_canvas" width="580" height="406" class="" style="display: none"></canvas>
                                        <div class="c-preview__image" :if="this.previewImage"><img :src="previewImage" alt="" /></div>
                                    </div>
                                </div>

                                <div class="c-interface__select">
                                    <!--menu-->
                                    <div class="c-interface__menu">
                                        <ul class="c-menu">
                                            <li class="c-menu__item" v-for="item in parts_menu" :key="item.id">
                                                <input type="radio" name="select" :value="item.name" :id="`menu-${item.name}`" v-model="current_parts" />
                                                <label :for="`menu-${item.name}`" :class="`c-menu__button c-menu__button--${item.name}`">{{ item.alt }}</label>
                                            </li>
                                        </ul>
                                    </div>

                                    <!--parts-->

                                    <div class="c-interface__parts">
                                        <div class="c-parts" v-show="current_parts === 'face'">
                                            <div class="c-parts__item" v-for="(image, index) in face" :key="image.id">
                                                <input type="radio" name="face" :id="`face-${index + 1}`" :value="image.src" v-model="selectedPart.face" @change="setCanvas" />
                                                <label :for="`face-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-face-${index + 1}.png`)" :alt="`ボディ${index + 1}`" /></label>
                                                <!-- <label :for="`face-${index + 1}`"><img :src="`../assets/img/ic-face-${index + 1}.png`" :alt="`ボディ${index + 1}`"></label> -->
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'hair'">
                                            <div class="c-parts__item" v-for="(image, index) in hair" :key="image.id">
                                                <input type="radio" name="hair" :id="`hair-${index + 1}`" :value="image.src" v-model="selectedPart.hair" @change="setCanvas" />
                                                <label :for="`hair-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-hair-${index + 1}.png`)" :alt="`ボディ${index + 1}`" /></label>
                                                <!-- <label :for="`hair-${index + 1}`"><img :src="`../assets/img/ic-hair-${index + 1}.png`" :alt="`ボディ${index + 1}`"></label> -->
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'eye'">
                                            <div class="c-parts__item" v-for="(image, index) in eye" :key="image.id">
                                                <input type="radio" name="eye" :id="`eye-${index + 1}`" :value="image.src" v-model="selectedPart.eye" @change="setCanvas" />
                                                <label :for="`eye-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-eye-${index + 1}.png`)" :alt="`目${index + 1}`" /></label>
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'eyebrows'">
                                            <div class="c-parts__item" v-for="(image, index) in eyebrows" :key="image.id">
                                                <input type="radio" name="eyebrows" :id="`eyebrows-${index + 1}`" :value="image.src" v-model="selectedPart.eyebrows" @change="setCanvas" />
                                                <label :for="`eyebrows-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-eyebrows-${index + 1}.png`)" :alt="`眉毛${index + 1}`" /></label>
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'nose'">
                                            <div class="c-parts__item" v-for="(image, index) in nose" :key="image.id">
                                                <input type="radio" name="nose" :id="`nose-${index + 1}`" :value="image.src" v-model="selectedPart.nose" @change="setCanvas" />
                                                <label :for="`nose-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-nose-${index + 1}.png`)" :alt="`鼻${index + 1}`" /></label>
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'mouth'">
                                            <div class="c-parts__item" v-for="(image, index) in mouth" :key="image.id">
                                                <input type="radio" name="mouth" :id="`mouth-${index + 1}`" :value="image.src" v-model="selectedPart.mouth" @change="setCanvas" />
                                                <label :for="`mouth-${index + 1}`"><img :src="require(`@/assets/img/menu/ic-mouth-${index + 1}.png`)" :alt="`口${index + 1}`" /></label>
                                            </div>
                                        </div>

                                        <div class="c-parts" v-show="current_parts === 'accessory'">
                                            <div class="c-parts__item" v-for="(image, index) in accessory" :key="image.id">
                                                <input type="radio" name="accessory" :id="`accessory-${index}`" :value="image.src" v-model="selectedPart.accessory" @change="setCanvas" />
                                                <label :for="`accessory-${index}`"><img :src="require(`@/assets/img/menu/ic-accessory-${index}.png`)" :alt="`アクセサリー${index}`" /></label>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="c-back-buttons">
                                        <button type="button" class="c-back-button" @click="genderSelectReset"><img src="../assets/img/btn-2-sagasu.png" class="c-button-img" /></button>
                                        <button type="button" class="c-next-button" @click="avatorSubmit"><img src="../assets/img/btn-1-sagasu.png" class="c-button-img" /></button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!--名前入力-->
                        <div class="l-container" v-show="!nameSet && genderSelected && avatorSet && !generatedImage">
                            <div class="c-name-page">
                                <div class="name-title">
                                    <img src="../assets/img/ui/ballon.png" />
                                </div>
                                <div class="nameInput">
                                    <v-text-field v-model="firstname" label="名前（なまえ）" single-line placeholder="えほんたろう" outlined class="inputFirstName" id="inputFirstName" :rules="nameRules" required></v-text-field>
                                </div>
                                <div class="birthdayInput" v-if="this.mode != 'kg'">
                                    <v-menu :ref="birthdayPicker" v-model="birthdayPicker" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-text-field :value="formatDate(date)" label="誕生日（たんじょうび）" readonly outlined clearable single-line v-bind="attrs" v-on="on" @click:clear="$emit('update:date', '')" />
                                        </template>
                                        <v-date-picker
                                            v-model="date"
                                            :active-picker.sync="activePicker"
                                            :max="new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10)"
                                            min="1950-01-01"
                                            locale="jp-JP"
                                            color="secondary"
                                            no-title
                                            :day-format="(date) => new Date(date).getDate()"
                                            @input="birthdayPicker = false"
                                        >
                                        </v-date-picker>
                                    </v-menu>
                                </div>
                                <div class="nameInput" v-if="this.mode != 'kg'">
                                    <v-select v-model="relation" :items="itemsFamily" label="続柄（ぞくがら）" outlined solo flat single-line class="birthdayYear"></v-select>
                                </div>
                                <div class="text-error" v-show="this.nameIsNotExist(this.firstname) == false">なまえ が つかわれているよ</div>
                                <button v-show="(this.mode != 'kg' && (!firstname || this.nameIsNotExist(firstname) == false || !this.date || !this.relation)) || (this.mode == 'kg' && !firstname)" type="button" class="button-boy">
                                    <img src="../assets/img/btn-3-sagasu.png" style="opacity: 0.2" />
                                </button>
                                <button v-show="firstname && this.nameIsNotExist(firstname) && ((this.date && this.relation) || this.mode == 'kg')" type="button" class="button-boy" @click="nameSubmit()"><img src="../assets/img/btn-3-sagasu.png" /></button>
                            </div>
                        </div>

                        <!--コンテンツ選択-->
                        <div class="l-container" v-show="!generatedImage && this.nameSet && !contentsSelected">
                            <div class="c-contents-list-page">
                                <div class="contents-title">
                                    <img src="../assets/img/ui/balloon-content-select.png" />
                                </div>
                                <div v-if="this.mode != 'sa'" class="contents-list" :v-if="this.avatarData">
                                    <div class="contents-item w-100" @click="generateImage('/peterpan')" v-show="this.mode == '' || this.mode == 'line' || this.mode == 'sa-rpa' || this.mode == 'epson' || this.mode == 'kg'">
                                        <img src="../assets/img/ui/btn/btn-peterpan.png" />
                                    </div>
                                    <div class="contents-item w-100" @click="generateImage('/hansel')" v-show="this.mode == '' || this.mode == 'line' || this.mode == 'sa-rpa' || this.mode == 'epson' || this.mode == 'kg'">
                                        <img src="../assets/img/ui/btn/btn-hansel.png" />
                                    </div>
                                    <div class="contents-item w-100" @click="generateImage('/mermaid')" v-show="this.mode == '' || this.mode == 'line' || this.mode == 'sa-rpa' || this.mode == 'epson'">
                                        <img src="../assets/img/ui/btn/btn-mermaid.png" />
                                    </div>
                                    <div class="contents-item w-100" @click="generateImage('/dino')" v-show="this.mode == ''">
                                        <img src="../assets/img/ui/btn/btn-dino.png" />
                                    </div>
                                    <div class="contents-item w-100" @click="generateImage('/cars')" v-show="this.mode == ''">
                                        <img src="../assets/img/ui/btn/btn-cars.png" />
                                    </div>
                                    <div class="contents-item w-100" @click="generateImage('/princess')" v-show="this.mode == ''">
                                        <img src="../assets/img/ui/btn/btn-princess.png" />
                                    </div>
                                </div>
                                <div v-if="this.mode == 'sa'" class="contents-list" :v-if="this.avatarData">
                                    <a class="contents-item w-100" href="https://lhco.li/3yhC9Cu">
                                        <img src="../assets/img/ui/btn/btn-peterpan.png" />
                                    </a>
                                    <a class="contents-item w-100" href="https://lhco.li/3J1gDH2">
                                        <img src="../assets/img/ui/btn/btn-hansel.png" />
                                    </a>
                                </div>
                            </div>
                        </div>

                        <!--ローディング画面-->
                        <transition name="c-loading">
                            <template v-if="loading">
                                <div class="c-loading">
                                    <div class="c-loading__message">作成中<span>・</span><span>・</span><span>・</span></div>
                                    <div class="c-loading__indicator">
                                        <div class="c-loading__item">
                                            <img src="../assets/img/indicator_01.png" alt="" />
                                        </div>
                                        <div class="c-loading__item">
                                            <img src="../assets/img/indicator_02.png" alt="" />
                                        </div>
                                        <div class="c-loading__item">
                                            <img src="../assets/img/indicator_03.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </template>
                        </transition>

                        <!--完成画面-->
                        <div class="l-container" v-if="nameSet && genderSelected && avatorSet && contentsSelected && generatedImage && previewImage">
                            <div class="c-preview-page">
                                <div class="top-title">
                                    <img src="../assets/img/title-sagasu.png" />
                                </div>
                                <SagasuPeterPan v-if="this.path == '/peterpan'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <SagasuHansel v-if="this.path == '/hansel'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <SagasuMermaid v-if="this.path == '/mermaid'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <SealDino v-if="this.path == '/dino'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <SealCars v-if="this.path == '/cars'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <SealPrincess v-if="this.path == '/princess'" :firstname="this.firstname" :avatarCanvas="this.avatar" :loadingContents="this.loading" v-on:loadingState="receiveChildLoading" :BoySelected="BoySelected" :mode="this.mode" :selectedPart="this.selectedPart" />
                                <div class="c-result__menu" v-if="this.mode == '' || this.mode == 'kg'">
                                    <div>
                                        <button type="button" class="c-button" @click="reset">もう一度作成する</button>
                                    </div>
                                </div>
                                <div class="campain" v-if="this.mode == 'epson'">
                                    <div class="campain-title">期間限定！キャンペーン実施中！</div>
                                    <hr class="campain-hr" />
                                    <div class="text-left p-20">
                                        <div class="campain-subtitle">アンケート回答で100名様にAmazonギフト券を抽選でプレゼント！</div>
                                        <div>期間：2023年3月31日（金）～2023年4月23日（日）</div>
                                        <div>絵探しプリントを体験してくださった方を対象に簡単なアンケートを実施しております。</div>
                                        <div>アンケートを回答してくれた方100名様に抽選でAmazonギフト券500円をプレゼント！</div>
                                    </div>
                                    <hr class="campain-hr" />
                                    <div class="text-left h-auto p-20">
                                        <div>条件：絵探しプリントに関するアンケートに回答</div>
                                        <div>（３分程度で回答可能なアンケートです。）</div>
                                        <div>※前回アンケート回答頂いた方は対象外となります。</div>
                                        <br />
                                        <div>特典：Amazonギフト券500円（Amazonギフト券はプライムギフトコードの送付となります。）</div>
                                        <div>アンケートは絵さがしプリントで遊んだ後、画面に表示されたアンケート回答ボタンよりご回答ください。</div>
                                    </div>
                                    <hr class="campain-hr" />
                                    <div class="h-auto p-20">
                                        <a class="mb-3 button--form" href="https://forms.gle/nUxLbneFiq445QeD9" target="_blank" rel="noopener noreferrer">アンケートに回答する</a>
                                    </div>
                                </div>
                                <div class="c-notice">
                                    <p>※iOSの場合はフォルダアプリ、Androidの場合はFiles、ギャラリーなどに保存されます。</p>
                                    <div class="c-notice" v-if="this.mode == 'epson'">本媒体上の他者商標の帰属先は、<a href="https://www.epson.jp/trademark/" target="_blank" rel="noopener noreferrer">商標について</a> をご確認ください。</div>
                                </div>

                                <div v-if="this.mode == 'epson'">
                                    <a href="https://form.ehon.inc/ep_esagashi" target="_blank" rel="noopener noreferrer" class="c-button-link">トップページに戻る</a>
                                </div>

                                <div class="">
                                    <a href="https://ehon-inc.jp/" target="_blank" rel="noopener noreferrer" class="c-button-link">オリジナル絵本作成サービス<br />「 ÉHON INC. 」についてはこちら</a>
                                </div>
                            </div>
                        </div>

                        <template v-if="generatedImage && !loading">
                            <div>
                                <div class="c-balloon--01"><img src="../assets/img/ui/balloon/balloon-01.svg" alt="" /></div>
                                <div class="c-balloon--02"><img src="../assets/img/ui/balloon/balloon-02.svg" alt="" /></div>
                                <div class="c-balloon--03"><img src="../assets/img/ui/balloon/balloon-03.svg" alt="" /></div>
                                <div class="c-balloon--04"><img src="../assets/img/ui/balloon/balloon-04.svg" alt="" /></div>
                                <div class="c-balloon--05"><img src="../assets/img/ui/balloon/balloon-05.svg" alt="" /></div>
                                <div class="c-balloon--06"><img src="../assets/img/ui/balloon/balloon-06.svg" alt="" /></div>
                                <div class="c-balloon--07"><img src="../assets/img/ui/balloon/balloon-07.svg" alt="" /></div>
                                <div class="c-balloon--08"><img src="../assets/img/ui/balloon/balloon-08.svg" alt="" /></div>
                                <div class="c-balloon--09"><img src="../assets/img/ui/balloon/balloon-09.svg" alt="" /></div>
                                <div class="c-balloon--10"><img src="../assets/img/ui/balloon/balloon-10.svg" alt="" /></div>
                                <div class="c-balloon--11"><img src="../assets/img/ui/balloon/balloon-11.svg" alt="" /></div>
                                <div class="c-balloon--12"><img src="../assets/img/ui/balloon/balloon-12.svg" alt="" /></div>
                                <div class="c-balloon--13"><img src="../assets/img/ui/balloon/balloon-06.svg" alt="" /></div>
                                <div class="c-balloon--14"><img src="../assets/img/ui/balloon/balloon-07.svg" alt="" /></div>
                                <div class="c-balloon--15"><img src="../assets/img/ui/balloon/balloon-02.svg" alt="" /></div>
                                <div class="c-balloon--16"><img src="../assets/img/ui/balloon/balloon-03.svg" alt="" /></div>
                                <div class="c-balloon--17"><img src="../assets/img/ui/balloon/balloon-12.svg" alt="" /></div>
                            </div>
                        </template>
                    </div>
                </div>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import firebase from "@/firebase/firebase";
import AvatarPreview from "@/components/AvatarPreview";
import SagasuPeterPan from "@/components/contents/SagasuPeterPan";
import SagasuHansel from "@/components/contents/SagasuHansel";
import SagasuMermaid from "@/components/contents/SagasuMermaid";
import SealDino from "@/components/contents/SealDino";
import SealCars from "@/components/contents/SealCars";
import SealPrincess from "@/components/contents/SealPrincess";
import { jsPDF } from "jspdf";
import axios from "axios";
axios.defaults.withCredentials = true;
axios.defaults.xsrfHeaderName = "X-CSRF-Token";

var WebFont = require("webfontloader");
WebFont.load({
    google: {
        families: ["Noto Sans JP"],
    },
    active: function () {
        // console.log("Google font is active.");
    },
});

export default {
    components: {
        AvatarPreview,
        SagasuPeterPan,
        SagasuHansel,
        SagasuMermaid,
        SealDino,
        SealCars,
        SealPrincess,
    },
    data() {
        return {
            mode: "epson", // null/line/epson/sa/sa-rpa/kg
            path: "",
            body: [
                {
                    src: "parts/body/body-1.png",
                },
                {
                    src: "parts/body/body-2.png",
                },
            ],
            face: [
                {
                    src: "parts/face/face-1.png",
                },
                {
                    src: "parts/face/face-2.png",
                },
                {
                    src: "parts/face/face-3.png",
                },
                {
                    src: "parts/face/face-4.png",
                },
                {
                    src: "parts/face/face-5.png",
                },
            ],
            hair: [
                {
                    src: "parts/hair/hair-1.png",
                },
                {
                    src: "parts/hair/hair-2.png",
                },
                {
                    src: "parts/hair/hair-3.png",
                },
                {
                    src: "parts/hair/hair-4.png",
                },
                {
                    src: "parts/hair/hair-5.png",
                },
                {
                    src: "parts/hair/hair-6.png",
                },
                {
                    src: "parts/hair/hair-7.png",
                },
                {
                    src: "parts/hair/hair-8.png",
                },
                {
                    src: "parts/hair/hair-9.png",
                },
                {
                    src: "parts/hair/hair-10.png",
                },
                {
                    src: "parts/hair/hair-11.png",
                },
                {
                    src: "parts/hair/hair-12.png",
                },
                {
                    src: "parts/hair/hair-13.png",
                },
                {
                    src: "parts/hair/hair-14.png",
                },
                {
                    src: "parts/hair/hair-15.png",
                },
                {
                    src: "parts/hair/hair-16.png",
                },
                {
                    src: "parts/hair/hair-17.png",
                },
                {
                    src: "parts/hair/hair-18.png",
                },
                {
                    src: "parts/hair/hair-19.png",
                },
                {
                    src: "parts/hair/hair-20.png",
                },
                {
                    src: "parts/hair/hair-21.png",
                },
                {
                    src: "parts/hair/hair-22.png",
                },
                {
                    src: "parts/hair/hair-23.png",
                },
                {
                    src: "parts/hair/hair-24.png",
                },
                {
                    src: "parts/hair/hair-25.png",
                },
                {
                    src: "parts/hair/hair-26.png",
                },
                {
                    src: "parts/hair/hair-27.png",
                },
                {
                    src: "parts/hair/hair-28.png",
                },
                {
                    src: "parts/hair/hair-29.png",
                },
                {
                    src: "parts/hair/hair-30.png",
                },
                {
                    src: "parts/hair/hair-31.png",
                },
                {
                    src: "parts/hair/hair-32.png",
                },
                {
                    src: "parts/hair/hair-33.png",
                },
                {
                    src: "parts/hair/hair-34.png",
                },
                {
                    src: "parts/hair/hair-35.png",
                },
                {
                    src: "parts/hair/hair-36.png",
                },
                {
                    src: "parts/hair/hair-37.png",
                },
                {
                    src: "parts/hair/hair-38.png",
                },
                {
                    src: "parts/hair/hair-39.png",
                },
                {
                    src: "parts/hair/hair-40.png",
                },
                {
                    src: "parts/hair/hair-41.png",
                },
                {
                    src: "parts/hair/hair-42.png",
                },
                {
                    src: "parts/hair/hair-43.png",
                },
                {
                    src: "parts/hair/hair-44.png",
                },
                {
                    src: "parts/hair/hair-45.png",
                },
                {
                    src: "parts/hair/hair-46.png",
                },
                {
                    src: "parts/hair/hair-47.png",
                },
            ],
            backhair: [
                {
                    src: "parts/backhair/backhair-1.png",
                },
                {
                    src: "parts/backhair/backhair-2.png",
                },
                {
                    src: "parts/backhair/backhair-3.png",
                },
                {
                    src: "parts/backhair/backhair-4.png",
                },
                {
                    src: "parts/backhair/backhair-5.png",
                },
                {
                    src: "parts/backhair/backhair-6.png",
                },
                {
                    src: "parts/backhair/backhair-7.png",
                },
                {
                    src: "parts/backhair/backhair-8.png",
                },
                {
                    src: "parts/backhair/backhair-9.png",
                },
                {
                    src: "parts/backhair/backhair-10.png",
                },
                {
                    src: "parts/backhair/backhair-11.png",
                },
                {
                    src: "parts/backhair/backhair-12.png",
                },
                {
                    src: "parts/backhair/backhair-13.png",
                },
                {
                    src: "parts/backhair/backhair-14.png",
                },
                {
                    src: "parts/backhair/backhair-15.png",
                },
                {
                    src: "parts/backhair/backhair-16.png",
                },
                {
                    src: "parts/backhair/backhair-17.png",
                },
                {
                    src: "parts/backhair/backhair-18.png",
                },
                {
                    src: "parts/backhair/backhair-19.png",
                },
                {
                    src: "parts/backhair/backhair-20.png",
                },
                {
                    src: "parts/backhair/backhair-21.png",
                },
                {
                    src: "parts/backhair/backhair-22.png",
                },
                {
                    src: "parts/backhair/backhair-23.png",
                },
                {
                    src: "parts/backhair/backhair-24.png",
                },
                {
                    src: "parts/backhair/backhair-25.png",
                },
                {
                    src: "parts/backhair/backhair-26.png",
                },
                {
                    src: "parts/backhair/backhair-27.png",
                },
                {
                    src: "parts/backhair/backhair-28.png",
                },
                {
                    src: "parts/backhair/backhair-29.png",
                },
                {
                    src: "parts/backhair/backhair-30.png",
                },
                {
                    src: "parts/backhair/backhair-31.png",
                },
                {
                    src: "parts/backhair/backhair-32.png",
                },
                {
                    src: "parts/backhair/backhair-33.png",
                },
                {
                    src: "parts/backhair/backhair-34.png",
                },
                {
                    src: "parts/backhair/backhair-35.png",
                },
                {
                    src: "parts/backhair/backhair-36.png",
                },
                {
                    src: "parts/backhair/backhair-37.png",
                },
                {
                    src: "parts/backhair/backhair-38.png",
                },
                {
                    src: "parts/backhair/backhair-39.png",
                },
                {
                    src: "parts/backhair/backhair-40.png",
                },
                {
                    src: "parts/backhair/backhair-41.png",
                },
                {
                    src: "parts/backhair/backhair-42.png",
                },
                {
                    src: "parts/backhair/backhair-43.png",
                },
                {
                    src: "parts/backhair/backhair-44.png",
                },
                {
                    src: "parts/backhair/backhair-45.png",
                },
                {
                    src: "parts/backhair/backhair-46.png",
                },
                {
                    src: "parts/backhair/backhair-47.png",
                },
            ],
            eye: [
                {
                    src: "parts/eye/eye-1.png",
                },
                {
                    src: "parts/eye/eye-2.png",
                },
                {
                    src: "parts/eye/eye-3.png",
                },
                {
                    src: "parts/eye/eye-4.png",
                },
                {
                    src: "parts/eye/eye-5.png",
                },
                {
                    src: "parts/eye/eye-6.png",
                },
                {
                    src: "parts/eye/eye-7.png",
                },
                {
                    src: "parts/eye/eye-8.png",
                },
                {
                    src: "parts/eye/eye-9.png",
                },
            ],
            nose: [
                {
                    src: "parts/nose/nose-1.png",
                },
                {
                    src: "parts/nose/nose-2.png",
                },
                {
                    src: "parts/nose/nose-3.png",
                },
                {
                    src: "parts/nose/nose-4.png",
                },
                {
                    src: "parts/nose/nose-5.png",
                },
                {
                    src: "parts/nose/nose-6.png",
                },
            ],
            accessory: [
                {
                    src: "parts/accessory/accessory-0.png",
                },
                {
                    src: "parts/accessory/accessory-1.png",
                },
                {
                    src: "parts/accessory/accessory-2.png",
                },
                {
                    src: "parts/accessory/accessory-3.png",
                },
                {
                    src: "parts/accessory/accessory-4.png",
                },
                {
                    src: "parts/accessory/accessory-5.png",
                },
                {
                    src: "parts/accessory/accessory-6.png",
                },
                {
                    src: "parts/accessory/accessory-7.png",
                },
                {
                    src: "parts/accessory/accessory-8.png",
                },
                {
                    src: "parts/accessory/accessory-9.png",
                },
            ],
            cheek: [
                {
                    src: "parts/other/cheek-1.png",
                },
            ],
            mouth: [
                {
                    src: "parts/mouth/mouth-1.png",
                },
                {
                    src: "parts/mouth/mouth-2.png",
                },
                {
                    src: "parts/mouth/mouth-3.png",
                },
                {
                    src: "parts/mouth/mouth-4.png",
                },
            ],
            eyebrows: [
                {
                    src: "parts/eyebrows/eyebrows-1.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-2.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-3.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-4.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-5.png",
                },
                {
                    src: "parts/eyebrows/eyebrows-6.png",
                },
            ],
            parts_menu: [
                {
                    name: "face",
                    alt: "輪郭",
                },
                {
                    name: "hair",
                    alt: "髪型",
                },
                {
                    name: "eyebrows",
                    alt: "眉毛",
                },
                {
                    name: "eye",
                    alt: "目",
                },
                {
                    name: "nose",
                    alt: "鼻",
                },
                {
                    name: "mouth",
                    alt: "口",
                },
                {
                    name: "accessory",
                    alt: "アクセサリー",
                },
            ],
            current_parts: "",
            selectedPart: {
                backhair: "",
                hair: "",
                // body: '',
                face: "",
                eye: "",
                nose: "",
                accessory: "",
                cheek: "",
                mouth: "",
                eyebrows: "",
            },
            genderSelected: "", // ローディング画面の表示
            BoySelected: true, // ローディング画面の表示
            loading: false, // ローディング画面の表示
            previewImage: "",
            generatedImage: "", // 画像ファイル名を格納
            generatedSeal: "", // シールファイル名を格納
            generatedP1: "", // シールファイル名を格納
            generatedP2: "", // シールファイル名を格納
            generatedP3: "", // シールファイル名を格納
            generatedP4: "", // シールファイル名を格納
            generatedP5: "", // シールファイル名を格納
            AvatarPosition: 1, //探すアバターの位置
            firstname: "",
            nameSet: false,
            avatorSet: false,
            nameRules: [(v) => !!v || "名前を入力してください", (v) => (v && v.length <= 10) || "名前は10文字以内にしてください"],
            user: "",
            email: "",
            avatarData: [],
            avatarDataExist: false,
            avatarSelected: false,
            contentsSelected: false,
            editIndex: "",
            avatar: "",
            itemsFamily: [
                { text: "父", value: "父" },
                { text: "母", value: "母" },
                { text: "長男", value: "長男" },
                { text: "次男", value: "次男" },
                { text: "三男", value: "三男" },
                { text: "長女", value: "長女" },
                { text: "次女", value: "次女" },
                { text: "三女", value: "三女" },
            ],
            relation: "",
            sex: "male",
            date: "",
            birthdayPicker: false,
            backAvatarSelectEnable: true,
            activePicker: null,
        };
    },
    head: {
        link: [
            { rel: "preconnect", href: "https://fonts.googleapis.com" },
            { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: true },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap" },
            { rel: "stylesheet", href: "https://fonts.googleapis.com/earlyaccess/roundedmplus1c.css" },
        ],
        script: [{ type: "text/javascript", src: "https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js" }],
    },
    async created() {
        this.email = await this.$route.query.email;
        // console.log("Email >> ", this.email);
        switch (this.mode) {
            case "kg":
                break;
            default:
                this.getContact(this.email);
                break;
        }
        this.path = this.$route.path;
    },
    watch: {
        birthdayPicker(val) {
            val && setTimeout(() => (this.activePicker = "YEAR"));
        },
    },
    mounted() {
        this.setDefault();
        this.setCanvas();
        switch (this.mode) {
            case "epson":
                break;
            case "line":
                break;
            default:
                break;
        }
    },
    methods: {
        setDefault: function () {
            // 初期値を代入
            this.selectedPart.backhair = this.backhair[0].src;
            if (this.BoySelected) {
                this.selectedPart.hair = this.hair[3].src;
                this.selectedPart.body = this.body[0].src;
            } else {
                this.selectedPart.hair = this.hair[23].src;
                this.selectedPart.body = this.body[1].src;
            }
            this.selectedPart.face = this.face[0].src;
            this.selectedPart.eye = this.eye[0].src;
            this.selectedPart.nose = this.nose[0].src;
            this.selectedPart.cheek = this.cheek[0].src;
            this.selectedPart.mouth = this.mouth[1].src;
            this.selectedPart.eyebrows = this.eyebrows[0].src;
            this.selectedPart.accessory = this.accessory[0].src;
            this.current_parts = "face";
        },
        async loadQuery() {
            const loadExistAvatar = this.loadExistAvatar;
            const nameSubmit = this.nameSubmit;
            const generateImage = this.generateImage;
            let queryRelation = await this.$route.query.relation;
            let queryContents = await this.$route.query.contents;
            let avatorSet = false;
            this.avatar = await document.getElementById("canvas");
            console.log("loadQuery.selectedPart", this.selectedPart);
            console.log("loadQuery.avatar", this.avatar);
            this.avatarData.forEach(async function (item, index) {
                // console.log(item.name, name);
                if (item?.relation == queryRelation) {
                    // console.log("関係あるよ", item.relation);
                    loadExistAvatar(item, index);
                    avatorSet = true;
                    setTimeout(function () {
                        nameSubmit();
                    }, 0);
                    setTimeout(async function () {
                        await generateImage(`/${queryContents}`);
                    }, 5000);
                } else {
                    // console.log("関係ないよ", item.relation);
                }
            });

            this.avatorSet = avatorSet;
        },
        receiveChildLoading(loading) {
            this.loading = loading;
        },
        birthdayPickerSave(date) {
            // this.$refs.birthdayPicker[0].save(date);
            console.log("this.$refs", this.$refs.birthdayPicker, date);
        },
        logout() {
            console.log("logout_call");
            firebase
                .auth()
                .signOut()
                .then(() => {
                    localStorage.message = "ログアウトに成功しました";
                    this.$router.push("/login");
                })
                .catch((error) => {
                    console.log("fail", error);
                });
        },
        setCanvas: async function () {
            //コンテンツ利用（Props）
            //後ろ髪をセットする
            this.selectedPart.backhair = "parts/backhair/back" + this.selectedPart.hair.split("/")[2];
            // Canvasに選択した画像を書き込む
            const $canvas = document.getElementById("canvas");
            const context = $canvas.getContext("2d");
            // パーツの生成をする順番（上から順）
            let imageOrder = [];
            imageOrder = ["face", "hair", "eye", "nose", "cheek", "mouth", "eyebrows", "accessory"];
            let dy = 0;
            context.clearRect(0, 0, $canvas.width, $canvas.height);
            for (let part of imageOrder) {
                const image = await this.setImage(context, part);
                //小さい顔を選択時、下に下げる
                if (part != "body" && this.selectedPart.face.split("-")[1].split(".")[0] == 2) {
                    dy = 25;
                } else {
                    dy = 0;
                }
                context.drawImage(image, 0, dy, $canvas.width, $canvas.height);
            }

            //ジェネレータプレビュー用
            this.avatar = document.getElementById("canvas");

            const $face_canvas = document.getElementById("face_canvas");
            const face_context = $face_canvas.getContext("2d");
            //パーツの生成をする順番（上から順）
            const face_imageOrder = ["backhair", "body", "face", "hair", "eye", "nose", "cheek", "mouth", "eyebrows", "accessory"];
            face_context.clearRect(0, 0, $face_canvas.width, $face_canvas.height);
            for (let part of face_imageOrder) {
                const face_image = await this.setImage(face_context, part);
                if (part != "body" && this.selectedPart.face.split("-")[1].split(".")[0] == 2) {
                    dy = 20;
                } else {
                    dy = 0;
                }
                face_context.drawImage(face_image, 0, dy, $face_canvas.width, $face_canvas.height);
            }
            const base64Image = face_context.canvas.toDataURL("image/png");
            this.previewImage = base64Image;

            // this.selectedPart.backhair = "parts/backhair/back" + this.selectedPart.hair.split("/")[2];

            // const backhair = new Image();
            // const body = new Image();
            // const face = new Image();
            // const hair = new Image();
            // const eye = new Image();
            // const nose = new Image();
            // const cheek = new Image();
            // const mouth = new Image();
            // const eyebrows = new Image();
            // const accessory = new Image();

            // backhair.src = require(`@/assets/img/${this.selectedPart["backhair"]}`);
            // body.src = require(`@/assets/img/${this.selectedPart["body"]}`);
            // face.src = require(`@/assets/img/${this.selectedPart["face"]}`);
            // hair.src = require(`@/assets/img/${this.selectedPart["hair"]}`);
            // eye.src = require(`@/assets/img/${this.selectedPart["eye"]}`);
            // nose.src = require(`@/assets/img/${this.selectedPart["nose"]}`);
            // cheek.src = require(`@/assets/img/${this.selectedPart["cheek"]}`);
            // mouth.src = require(`@/assets/img/${this.selectedPart["mouth"]}`);
            // eyebrows.src = require(`@/assets/img/${this.selectedPart["eyebrows"]}`);
            // accessory.src = require(`@/assets/img/${this.selectedPart["accessory"]}`);

            // let LoadImages = [];
            // LoadImages = [backhair, body, face, hair, eye, nose, cheek, mouth, eyebrows, accessory];

            // let dy = 0;
            // if(this.selectedPart.face.split("-")[1].split(".")[0] == 2){
            //     dy = 20;
            // }

            // const $canvas = document.getElementById("canvas");
            // const context = $canvas.getContext("2d");
            // await this.setLoadAllCallback(LoadImages, function () {
            //     context.drawImage(face, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(hair, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(eye, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(nose, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(cheek, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(mouth, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(eyebrows, 0, dy, $canvas.width, $canvas.height);
            //     context.drawImage(accessory, 0, dy, $canvas.width, $canvas.height);
            // });

            // const $face_canvas = document.getElementById("face_canvas");
            // const face_context = $face_canvas.getContext("2d");
            // await this.setLoadAllCallback(LoadImages, function () {
            //     face_context.drawImage(backhair, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(body, 0, 0, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(face, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(hair, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(eye, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(nose, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(cheek, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(mouth, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(eyebrows, 0, dy, $face_canvas.width, $face_canvas.height);
            //     face_context.drawImage(accessory, 0, dy, $face_canvas.width, $face_canvas.height);
            // });

            // const base64Image = face_context.canvas.toDataURL("image/png");
            // this.previewImage = base64Image;
        },
        setLoadAllCallback: function (elems, callback) {
            var count = 0;
            for (var i = 0; i < elems.length; ++i) {
                elems[i].onload = function () {
                    ++count;
                    if (count == elems.length) {
                        // All elements have been loaded.
                        callback(elems);
                    }
                };
            }
        },
        setImage: function (context, part) {
            // 画像を順番通りに読み込ませる
            const imageName = this.selectedPart[part];
            return new Promise(function (resolve, reject) {
                const image = new Image();
                image.src = require(`@/assets/img/${imageName}`);
                image.onload = function () {
                    resolve(image);
                };

                image.onerror = function (e) {
                    console.log(e);
                    reject("画像の読み込みに失敗しました");
                };
            });
        },
        generateImage: async function (contentName) {
            console.log("call generateImage >> ", this.path);
            this.path = contentName;
            this.loading = true;
            this.contentsSelected = true;
            // 画像をBase64形式に変換
            if (this.mode != "kg") {
                this.updateContact();
            }
            const $canvas = await document.getElementById("canvas");
            const context = await $canvas.getContext("2d");
            const base64Image = await context.canvas.toDataURL("image/png");
            this.generatedImage = await base64Image;
            // this.generateContent();
            // setTimeout(this.previewContent, 3000);
            // setTimeout(this.loadingClose, 5000);
        },
        async previewContent() {
            console.log("call : previewContent");
            //P1
            const $p1_canvas_new = await document.getElementById("p1_canvas");
            const p1_context_new = await $p1_canvas_new.getContext("2d");
            const base64_p1 = await p1_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP1 = await base64_p1;
            // console.log("done : ",this.generatedP1);
            //P2
            const $p2_canvas_new = await document.getElementById("p2_canvas");
            const p2_context_new = await $p2_canvas_new.getContext("2d");
            const base64_p2 = await p2_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP2 = await base64_p2;
            // console.log("done : ",this.generated2);
            //P3
            const $p3_canvas_new = await document.getElementById("p3_canvas");
            const p3_context_new = await $p3_canvas_new.getContext("2d");
            const base64_p3 = await p3_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP3 = await base64_p3;
            // console.log("done : ",this.generatedP3);
            //P4
            const $p4_canvas_new = await document.getElementById("p4_canvas");
            const p4_context_new = await $p4_canvas_new.getContext("2d");
            const base64_p4 = await p4_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP4 = await base64_p4;
            // console.log("done : ",this.generatedP4);
            //P5
            const $p5_canvas_new = await document.getElementById("p5_canvas");
            const p5_context_new = await $p5_canvas_new.getContext("2d");
            const base64_p5 = await p5_context_new.canvas.toDataURL("image/jpeg", 0.6);
            this.generatedP5 = await base64_p5;
            // console.log("done : ",this.generatedP5);

            console.log("done : previewContent");
        },
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${year}/${month}/${day}`;
        },
        loadingClose: function () {
            // タイマーで動作させたい処理
            this.loading = false;
            console.log("done : loadingClose");
        },
        downloadImage: function () {
            // 生成した画像をダウンロードする
            const $canvas = document.getElementById("canvas");
            const $a = document.createElement("a");
            $a.href = $canvas.toDataURL("image/png");
            $a.download = "contents.png";
            $a.click();
        },
        reset: function () {
            // 生成した画像をリセットする
            this.avatarSelected = false;
            this.contentsSelected = false;
            this.generatedImage = "";
            this.generatedSeal = "";
            this.genderSelected = false;
            this.BoySelected = true;
            this.nameSet = false;
            this.avatorSet = false;
            switch (this.mode) {
                case "line":
                    break;
                default:
                    break;
            }
        },
        genderSelectBoy: function () {
            this.genderSelected = true;
            this.BoySelected = true;
            this.setDefault();
            this.setCanvas();
        },
        genderSelectGirl: function () {
            this.genderSelected = true;
            this.BoySelected = false;
            this.setDefault();
            this.setCanvas();
        },
        genderSelectReset: function () {
            this.genderSelected = false;
            this.BoySelected = true;
            // console.log("check EditIndex", this.editIndex);
            if (this.editIndex !== "") {
                this.avatarSelected = false;
                this.editIndex = "";
                // console.log("reset EditIndex", this.editIndex);
            }
        },
        nameSubmit: function () {
            switch (this.mode) {
                case "epson":
                    this.nameSet = true;
                    break;
                case "line":
                    this.nameSet = true;
                    this.generateImage();
                    break;
                case "sa-rpa":
                    this.nameSet = true;
                    break;
                case "sa":
                    this.updateContact();
                    this.nameSet = true;
                    break;
                default:
                    this.nameSet = true;
                    break;
            }
        },
        avatorSubmit: function () {
            this.avatorSet = true;
        },
        backAvatarSelect: function () {
            this.avatarSelected = false;
            this.genderSelected = false;
            this.editIndex = null;
        },
        createNewAvatar: function () {
            this.avatarSelected = true;
            this.firstname = "";
            this.relation = "";
            this.date = "";
            this.sex = "male";
        },
        nameIsNotExist: function (name) {
            // console.log("名前の存在確認 >> ", this.avatarData);
            // console.log("firstname >> ", name);
            let result = false;
            if (this.editIndex !== "") {
                // console.log("result true (データ編集)");
                return true;
            }
            if (!this.avatarData || this.avatarData == "[]" || this.avatarData == null || this.avatarData.length == 0) {
                // console.log("result true (データが空)");
                return true;
            }
            if (!name) {
                // console.log("result false(なまえが空)");
                return true;
            }
            this.avatarData.forEach(function (item) {
                // console.log(item.name, name);
                if (item.name == name) {
                    // console.log("なまえあるよ");
                    result = false;
                } else {
                    // console.log("なまえないよ");
                    result = true;
                }
            });
            // console.log("result", result);
            return result;
        },
        loadExistAvatar: function (propsAvatarData, index) {
            // console.log("Call loadExistAvatar >> ", propsAvatarData);
            this.selectedPart.backhair = this.backhair[propsAvatarData.hair["id"] - 1].src;
            this.selectedPart.hair = this.hair[propsAvatarData.hair["id"] - 1].src;
            this.selectedPart.body = this.body[propsAvatarData.body["id"] - 1].src;
            this.selectedPart.face = this.face[propsAvatarData.face["id"] - 1].src;
            this.selectedPart.eye = this.eye[propsAvatarData.eye["id"] - 1].src;
            this.selectedPart.nose = this.nose[propsAvatarData.nose["id"] - 1].src;
            this.selectedPart.cheek = this.cheek[0].src;
            this.selectedPart.mouth = this.mouth[propsAvatarData.mouth["id"] - 1].src;
            this.selectedPart.eyebrows = this.eyebrows[propsAvatarData.eyebrows["id"] - 1].src;
            if (propsAvatarData.accessory["id"] == 0) {
                this.selectedPart.accessory = this.accessory[0].src;
            } else {
                this.selectedPart.accessory = this.accessory[propsAvatarData.accessory["id"]].src;
            }
            this.firstname = propsAvatarData.name;
            this.date = propsAvatarData.birthday;
            this.relation = propsAvatarData.relation;
            this.sex = propsAvatarData.sex;
            if (this.sex == "male" || this.sex == "") {
                this.BoySelected = true;
            } else {
                this.BoySelected = false;
            }
            this.avatarSelected = true;
            this.genderSelected = true;
            this.editIndex = index;
            // console.log("this.editIndex", this.editIndex);
            this.setCanvas();
        },
        downloadPDF: function () {
            const pdf = new jsPDF("l", "pt", [3509, 2481], true);
            var width = pdf.internal.pageSize.width * 1;
            var height = pdf.internal.pageSize.height * 1;

            const p1_canvas = document.getElementById("p1_canvas");
            var p1_image_base64 = p1_canvas.toDataURL("image/jpeg", 0.6);
            const p1_image = new Image();
            p1_image.src = p1_image_base64;
            pdf.addImage(p1_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p2_canvas = document.getElementById("p2_canvas");
            var p2_image_base64 = p2_canvas.toDataURL("image/jpeg", 0.6);
            const p2_image = new Image();
            p2_image.src = p2_image_base64;
            pdf.addImage(p2_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p3_canvas = document.getElementById("p3_canvas");
            var p3_image_base64 = p3_canvas.toDataURL("image/jpeg", 0.6);
            const p3_image = new Image();
            p3_image.src = p3_image_base64;
            pdf.addImage(p3_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p4_canvas = document.getElementById("p4_canvas");
            var p4_image_base64 = p4_canvas.toDataURL("image/jpeg", 0.6);
            const p4_image = new Image();
            p4_image.src = p4_image_base64;
            pdf.addImage(p4_image, "PNG", 0, 0, width, height, "", "FAST");

            pdf.addPage();

            const p5_canvas = document.getElementById("p5_canvas");
            var p5_image_base64 = p5_canvas.toDataURL("image/jpeg", 1);
            const p5_image = new Image();
            p5_image.src = p5_image_base64;
            pdf.addImage(p5_image, "PNG", 0, 0, width, height, "", "FAST");

            var name = this.firstname;
            var fname = "SAGAS_EHON_" + name + ".pdf";
            pdf.save(fname);
        },
        getContact(email) {
            if (!email) {
                return 0;
            }
            // console.log("ユーザー取得 email：", email);
            axios
                .post("https://dev.bizreal.co.jp/api/hubspot/contact/show", {
                    email: email,
                })
                .then((response) => {
                    // console.log("レスポンス：", response);
                    this.user = response.data.user;
                    if (this.user.properties.avatar_1 == "" || this.user.properties.avatar_1 == null) {
                        return;
                    }
                    let avatar_1 = JSON.parse(response.data.user.properties.avatar_1);
                    // console.log("APIデータ : >> ", avatar_1[0].name);
                    this.avatarData = avatar_1;

                    if (this.user.properties?.avatar_1) {
                        this.avatarDataExist = true;
                        if (this.mode == "sa-rpa") {
                            this.loadQuery();
                        }
                    } else {
                        this.avatarDataExist = false;
                        this.avatarSelected = true;
                    }
                })
                .catch((err) => {
                    console.log("err", err);
                });
        },
        updateContact() {
            console.log("ユーザー更新：");
            // console.log("データ selectedPart >> ", this.selectedPart);
            // console.log("データ selectedPart >> ", this.selectedPart.face.split("-")[1]);
            // console.log("データ selectedPart >> ", this.selectedPart.face.split("-")[1].split(".")[0]);
            var user = this.user;
            var body_id = this.selectedPart.body.split("-")[1].split(".")[0];
            var face_id = this.selectedPart.face.split("-")[1].split(".")[0];
            var hair_id = this.selectedPart.hair.split("-")[1].split(".")[0];
            var eyebrows_id = this.selectedPart.eyebrows.split("-")[1].split(".")[0];
            var eye_id = this.selectedPart.eye.split("-")[1].split(".")[0];
            var nose_id = this.selectedPart.nose.split("-")[1].split(".")[0];
            var mouth_id = this.selectedPart.mouth.split("-")[1].split(".")[0];
            var accessory_id = this.selectedPart.accessory.split("-")[1].split(".")[0];
            var beard_id = "0";
            var mole_id = "0";
            var date = this.date;
            var sex = "male";
            if (this.BoySelected) {
                sex = "male";
            } else {
                sex = "female";
            }
            var relation = this.relation;
            let data = {
                id: user.id,
                name: this.firstname,
                relation: relation,
                birthday: date,
                sex: sex,
                body: {
                    id: body_id,
                },
                face: {
                    id: face_id,
                    color: "#000000",
                    makeupId: "0",
                    wrinkles: "0",
                },
                hair: {
                    id: hair_id,
                    color: "#000000",
                },
                eyebrows: {
                    id: eyebrows_id,
                    color: "#000000",
                    position: {
                        y: "0",
                        gap: "0",
                        rotate: "0",
                    },
                },
                eye: {
                    id: eye_id,
                    color: "#000000",
                    position: {
                        y: "0",
                        scale: "0",
                        gap: "0",
                        rotate: "0",
                    },
                },
                nose: {
                    id: nose_id,
                    color: "#000000",
                    position: {
                        y: "0",
                        scale: "0",
                    },
                },
                mouth: {
                    id: mouth_id,
                    position: {
                        y: "0",
                        scale: "0",
                    },
                },
                accessory: {
                    id: accessory_id,
                    color: "#000000",
                    position: {
                        y: "0",
                    },
                },
                beard: {
                    id: beard_id,
                    color: "#000000",
                },
                mole: {
                    id: mole_id,
                },
                updated_at: Date(),
            };

            if (this.editIndex !== "") {
                this.avatarData.splice(this.editIndex, 1, data);
            } else {
                this.avatarData.push(data);
            }
            console.log("送信データ:", this.avatarData);
            axios
                .post("https://dev.bizreal.co.jp/api/hubspot/contact/update", {
                    contactId: user.id,
                    avatar_1: JSON.stringify(this.avatarData),
                })
                .then((response) => {
                    console.log("成功：レスポンス：", response);
                    user = response.data.user;
                })
                .catch((err) => {
                    console.log("err", err);
                });
        },
        deleteContact(index) {
            // console.log("ユーザー削除：", index);
            var user = this.user;
            let data = this.avatarData;
            data.splice(index, 1);
            // console.log("送信データ:", data);
            axios
                .post("https://dev.bizreal.co.jp/api/hubspot/contact/update", {
                    contactId: user.id,
                    avatar_1: JSON.stringify(data),
                })
                .then((response) => {
                    // console.log("ユーザー削除成功：レスポンス：", response);
                    this.user = response.data.user;
                    if (this.user.properties.avatar_1 == "" || this.user.properties.avatar_1 == "[]") {
                        return;
                    }
                    this.getContact(this.email);
                })
                .catch((err) => {
                    console.log("err", err);
                });
        },
        APItest: function () {
            console.log("Call >> API TEST");
            var user = this.user;
            var body_id = this.selectedPart.body.split("-")[1].split(".")[0];
            var face_id = this.selectedPart.face.split("-")[1].split(".")[0];
            var hair_id = this.selectedPart.hair.split("-")[1].split(".")[0];
            var eyebrows_id = this.selectedPart.eyebrows.split("-")[1].split(".")[0];
            var eye_id = this.selectedPart.eye.split("-")[1].split(".")[0];
            var nose_id = this.selectedPart.nose.split("-")[1].split(".")[0];
            var mouth_id = this.selectedPart.mouth.split("-")[1].split(".")[0];
            var accessory_id = this.selectedPart.accessory.split("-")[1].split(".")[0];
            var beard_id = "0";
            var mole_id = "0";
            var date = this.date;
            var sex = "male";
            if (this.BoySelected) {
                sex = "male";
            } else {
                sex = "female";
            }
            var relation = this.relation;
            let data = {
                id: user.id,
                name: this.firstname,
                relation: relation,
                birthday: date,
                sex: sex,
                body: body_id,
                face: face_id,
                hair: hair_id,
                eyebrows: eyebrows_id,
                eye: eye_id,
                nose: nose_id,
                mouth: mouth_id,
                accessory: accessory_id,
                beard: beard_id,
                mole: mole_id,
            };
            // let json_data = JSON.stringify(data);
            // console.log("get api data", json_data);
            // let url = `https://dev.bizreal.co.jp/api/v1/generator/create?avatar=${json_data}`;
            // console.log("get api url", url);
            // axios
            //     .get(url)
            //     .then((response) => {
            //         console.log("レスポンス：", response);
            //     })
            //     .catch((err) => {
            //         console.log("err", err);
            //     });
            let url = `https://dev.bizreal.co.jp/api/v1/generator/create`;
            axios
                .post(url, {
                    avatar: JSON.stringify(data),
                })
                .then((response) => {
                    console.log("レスポンス：", response);
                })
                .catch((err) => {
                    console.log("err", err);
                });
        },
    },
};
</script>

<style>
@import "../assets/css/app.css";
@import url("https://fonts.googleapis.com/css2?family=M+PLUS+Rounded+1c&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@700&display=swap");

.button-logout {
    color: gray;
    margin-top: 20px;
    font-size: 14px;
}
</style>
